import PageDescription from "~/components/PageDescription";
import styles from "~/pages/VESISPage/NoActiveLock/NoActiveLock.pcss";
import React from "react";

export function VesisDescription() {
	return <PageDescription>
		{`SIS -> veSIS`}
		<br />
		Staking SIS tokens and becoming a veSIS holder unlocks exclusive benefits such as:
		<div>- Voting power in the <a href="https://snapshot.org/#/symbiosisdao.eth"
									  className={styles.link}
									  target="_blank"
									  rel="noreferrer noopener">Symbiosis DAO</a></div>
		<div>- Boosted <a href="https://app.symbiosis.finance/liquidity-v2/pools"
						  className={styles.link}
						  target="_blank"
						  rel="noreferrer noopener">APR for liquidity provision</a></div>
		<div>- Cross-chain <a href="https://medium.com/@symbiosis_fi/introducing-a-fee-discount-system-for-vesis-holders-087e9172d6af"
							  className={styles.link}
							  target="_blank"
							  rel="noreferrer noopener">fees reductions</a>: up to 60%!</div>
		<div>- Rewards for staking SIS tokens</div>
	</PageDescription>
}
